import { SaveOutlined, ReloadOutlined, EditOutlined, DeleteOutlined, DownloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { xuatExcelPhuCapToGiupViec, xacNhanLuongPhuCapToGiaoViec, layChiTietPhuCapToGiupViec, luuPhuCapToGiupViec, tinhPhuCapToGiupViec, xoaLuongPhuCapToGiaoViec } from "../../../services/luong";
import { toast } from "react-toastify";
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, Tag } from "antd";
import { arrayCommon, currencyFormat, dateCommon, formatVND, validateMessages } from '../../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import dayjs from 'dayjs';
import { ContentHeader } from '../../../components';
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { useNavigate } from 'react-router-dom';
import { Links } from '../../../helpers/Links';
import Column from 'antd/es/table/Column';

const optionsLoai = [
    {
        value: 1,
        label: "Theo tháng"
    },
    {
        value: 2,
        label: "Theo quý"
    },
]

const ChiTietPhuCapTGV = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);

    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalDuyet, setShowModalDuyet] = useState<boolean>(false);
    const [loaiChuKy, setLoaiChuKy] = useState<number>(1);
    const [checkAll, setCheckAll] = useState(true);

    const [dataLuongBoSung, setDataLuongBoSung] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [trangThai, setTrangThai] = useState<number>(-1);
    const [ghiChu, setGhiChu] = useState<string>('');

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            mucLuongCoSo: parsedValue,
            mucLuongCoSoStr: format
        });
        if (dataLuongBoSung.length > 0 && loaiChuKy !== 1) {
            dataLuongBoSung.forEach((item, index) => {
                dataLuongBoSung[index].mucLuongCoSo = parsedValue,
                    dataLuongBoSung[index].mucLuongDuocNhan = item.heSo * item.soThangLamViec * parsedValue
                setDataLuongBoSung([...dataLuongBoSung])
            })
        }
    };

    const eventXacNhan = async () => {
        try {
            setShowModalDuyet(false);
            dispatch(showLoadingScreen());
            await xacNhanLuongPhuCapToGiaoViec(id);
            navigate(Links.Luong.DanhSachPhuCapTGV);
            toast.success("Xác nhận lương phụ cấp tổ giúp việc thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventSavePhuCapTGV = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                if (dataLuongBoSung.length <= 0) {
                    toast.error("Không có dữ liệu tính lương phụ cấp tổ giúp việc");
                }
                else {
                    var request: any = {
                        id: id,
                        ten: values.ten,
                        thangNam: values.thangNam,
                        loaiChuKy: values.loaiChuKy,
                        ghiChu: ghiChu,
                        quy: values?.loaiChuKy !== 1 && form.getFieldValue('thoiGianQuyetToanQuy')
                            ? form.getFieldValue('thoiGianQuyetToanQuy')?.$M / 3 + 1
                            : 0,
                        nam: values?.loaiChuKy !== 1
                            ? form.getFieldValue('thoiGianQuyetToanQuy')?.$y
                            : form.getFieldValue('thangNam')?.$y,
                        mucLuongCoSo: parseInt(values?.mucLuongCoSo),
                        dsPhuCapToGiupViec: dataLuongBoSung,
                    };
                    const savedId = await luuPhuCapToGiupViec(request);
                    toast.success("Lưu phụ cấp tổ giúp việc thành công");
                    const targetId = savedId || id;
                    if (targetId) {
                        navigate(`${Links.Luong.ChiTietPhuCapTGV}?id=${targetId}`);
                        getById(targetId);
                    }
                }
            } catch (error: any) {
                toast.error(error.message);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra!");
        });
    }

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaLuongPhuCapToGiaoViec(id);
            navigate(Links.Luong.DanhSachPhuCapTGV);
            toast.success("Xóa lương phụ cấp tổ giúp việc thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const getById = async (id: any) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var response = await layChiTietPhuCapToGiupViec(id);
            loadData(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const taiDuLieu = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                var request = {
                    "quy": values?.loaiChuKy !== 1 && form.getFieldValue('thoiGianQuyetToanQuy')
                        ? form.getFieldValue('thoiGianQuyetToanQuy')?.$M / 3 + 1
                        : 0,
                    "nam": values?.loaiChuKy !== 1
                        ? form.getFieldValue('thoiGianQuyetToanQuy')?.$y
                        : form.getFieldValue('thangNam')?.$y,
                    "mucLuongCoSo": parseInt(values?.mucLuongCoSo),
                    "loaiChuKy": values?.loaiChuKy,
                    "thangNam": values?.thangNam
                }
                var data = await tinhPhuCapToGiupViec(request);
                setDataLuongBoSung(data);
            } catch (e: any) {
                toast.error(e);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const loadData = (response: any) => {
        setId(response.id);
        var format = currencyFormat.formatMoney(response.mucLuongCoSo + "");
        var dform: any = {
            id: response.id,
            ten: response.ten,
            thangNam: response.thangNam != null ? dayjs(dateCommon.formatDate(new Date(response.thangNam), "dd/MM/yyyy"), "DD/MM/YYYY") : undefined,
            kyLuongNam: dayjs(new Date(response.nam, 1, 1)),
            mucLuongCoSo: response.mucLuongCoSo + "",
            mucLuongCoSoStr: format,
            trangThai: response.trangThai,
            loaiChuKy: response.loaiChuKy ?? 1,
            thoiGianQuyetToanQuy: dayjs(dateCommon.formatDate(new Date(response?.nam, (response?.quy != null && response?.quy < 5) ? response?.quy * 3 - 3 : 6, 1)), "DD/MM/YYYY")
        };
        setTrangThai(response.trangThai);
        setGhiChu(response.ghiChu ?? '');
        form.setFieldsValue(dform);
        setIsEdit(false);
        setDataLuongBoSung(response.dsPhuCapToGiupViec);
    }
    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatExcelPhuCapToGiupViec(id);
            let link = document.createElement('a');
            link.download = `${form.getFieldValue('ten') || 'PhuCapToGiupViec_HDQL'}.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idLQT = +(params.get('id') || '');
        if (idLQT) {
            getById(idLQT);
        }
    }, [])

    return <section>
        {showModalDelete && <ModalTextForm show
            title="Xoá phụ cấp tổ giúp việc HĐQL"
            handleClose={() => setShowModalDelete(false)}
            handleSave={eventDelete}>
            Xác nhận xóa phụ cấp tổ giúp việc HĐQL
        </ModalTextForm>}
        {showModalDuyet && <ModalTextForm show
            title="Xác nhận phụ cấp tổ giúp việc HĐQL"
            handleClose={() => setShowModalDuyet(false)}
            handleSave={eventXacNhan}>
            Xác nhận phụ cấp tổ giúp việc HĐQL
        </ModalTextForm>}
        <ContentHeader title="Phụ cấp tổ giúp việc HĐQL" />
        <Tabs
            tabBarExtraContent={
                <Space>
                    <Button type="default" icon={<ArrowLeftOutlined rev="" />} onClick={() => { navigate(Links.Luong.DanhSachPhuCapTGV) } }>
                        Quay lại
                    </Button>
                    {trangThai <= 0 &&
                        <Button
                            type="default"
                            icon={<EditOutlined rev="" />}
                            onClick={() => {
                                setIsEdit(!isEdit);
                            }}
                        >
                            {
                                !isEdit ? "Chỉnh sửa" : "Khóa"
                            }
                        </Button>
                    }
                    {
                        id > 0 &&
                        <Button
                            loading={isLoading}
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined rev="" />}
                            onClick={handleExport}
                        >Xuất excel
                        </Button>
                    }                  
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary" danger
                            icon=<DeleteOutlined rev="" />
                            onClick={() => { setShowModalDelete(true) }}
                        >
                            Xóa
                        </Button>
                    }
                    {
                        id > 0 && (trangThai == 0 || trangThai == 2) && !isEdit &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalDuyet(true) }}
                        >
                            Xác nhận
                        </Button>
                    }
                    {
                        (trangThai <= 0 || trangThai == undefined) &&
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={eventSavePhuCapTGV}
                        >
                            Lưu
                        </Button>
                    }
                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Thông tin",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="10" >
                                            <Form.Item hidden name="id"><Input /></Form.Item>
                                            <Form.Item hidden name="trangThai"><Input /></Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Tên kỳ tính phụ cấp" name="ten">
                                                <Input readOnly={trangThai > 0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span="4">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Chu kỳ tính" name="loaiChuKy">
                                                <Select notFoundContent="Không có dữ liệu"
                                                    disabled={trangThai >= 0}
                                                    options={optionsLoai}
                                                    loading={isLoading}
                                                    onChange={(e) => {
                                                        setLoaiChuKy(e);
                                                    }}
                                                    placeholder="Chu kỳ tính phụ cấp" />
                                            </Form.Item>
                                        </Col>
                                        <Col span="4">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label={loaiChuKy === 1 ? "Thù lao CB/tháng HĐQL CT" : "Mức lương cơ sở"} name="mucLuongCoSoStr">
                                                <Input prefix="₫ " readOnly={trangThai > 0}
                                                    onChange={handleChangeCurrency}
                                                />
                                            </Form.Item>
                                            <Form.Item hidden name="mucLuongCoSo" >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        {loaiChuKy === 2 && <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: loaiChuKy === 2
                                                },
                                            ]} label="Kỳ quyết toán" name="thoiGianQuyetToanQuy">
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={id > 0 ? true : false}
                                                    style={{ width: "100%" }}
                                                    format="[Quý] Q/YYYY"
                                                    placeholder="Chọn thời gian"
                                                    picker="quarter" />
                                            </Form.Item>
                                        </Col>}
                                        {loaiChuKy === 1 && <Col span="6">
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: loaiChuKy === 1
                                                    },
                                                ]}
                                                label="Tháng năm" name="thangNam" >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    picker="month"
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn tháng"
                                                    format={["MM/YYYY", "MMYYYY"]}
                                                    allowClear={false}
                                                />
                                            </Form.Item>
                                        </Col>}
                                        {
                                            id > 0 &&
                                            <Col span="6">
                                                <Form.Item label="Trạng thái">
                                                    {
                                                        trangThai == 0 &&
                                                        <Tag color="processing">Khởi tạo</Tag>
                                                    }
                                                    {
                                                        trangThai == 1 &&
                                                        <Tag color="success">Đã duyệt</Tag>
                                                    }
                                                    {
                                                        trangThai == 2 &&
                                                        <Tag color="warning">Trình duyệt</Tag>
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                    {
                                        id == 0 && trangThai < 0 ?
                                            <Row>
                                                <Space>
                                                    <Button
                                                        onClick={taiDuLieu}
                                                        type="primary"
                                                        loading={isLoading}
                                                        icon={<ReloadOutlined rev="" />}>
                                                        Tải dữ liệu tính phụ cấp TGV
                                                    </Button>
                                                </Space>
                                            </Row> : null
                                    }
                                </Form>
                            </Col>
                        </Row>
                }]} />        
        <Row gutter={8} className="form-group mt-2">
            <Col span={24}>
                <div className="card card-primary" style={{ padding: '15px' }}>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                    {trangThai !== 1 ? (
                        <Input.TextArea
                            rows={3}
                            placeholder="Nhập ghi chú..."
                            value={ghiChu}
                            onChange={(e) => setGhiChu(e.target.value)}
                        />
                    ) : (
                        <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                            {ghiChu || 'Không có ghi chú'}
                        </div>
                    )}
                </div>
            </Col>
        </Row>
        <div className="card card-primary mt-2">
            <Table
                sticky
                scroll={{ x: 1500 }}
                loading={isLoading}
                dataSource={(dataLuongBoSung || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                locale={{ emptyText: "Không có dữ liệu" }}
                pagination={false}
                bordered={true}
                summary={pageData => {
                    let totalMucLuongDuocNhan = 0;
                    pageData.forEach(({ mucLuongDuocNhan }) => {
                        totalMucLuongDuocNhan += mucLuongDuocNhan;
                    });
                    const emptyCellCount = loaiChuKy === 1 ? 4 : 3;

                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={2} align="center">
                                <label>Tổng cộng</label>
                            </Table.Summary.Cell>
                            {Array.from({ length: emptyCellCount }).map((_, i) => (
                                <Table.Summary.Cell key={i} index={2 + i} />
                            ))}
                            <Table.Summary.Cell index={2 + emptyCellCount} align="right">
                                <label>{formatVND(totalMucLuongDuocNhan)}</label>
                            </Table.Summary.Cell>
                            {trangThai <= 0 && (
                                <Table.Summary.Cell index={2 + emptyCellCount + 1} />
                            )}
                        </Table.Summary.Row>
                    );
                }}
            >
                <Column title="Họ và tên" key="hoTen" dataIndex="hoTen" />
                <Column title="Chức vụ" key="tenChucVu" dataIndex="tenChucVu" />
                {loaiChuKy !== 1 && <Column title="Hệ số" align="center" key="heSo" dataIndex="heSo" />}
                <Column title={loaiChuKy === 1 ? "Mức lương cơ bản/tháng của thành viên HĐQL chuyên trách" : "Mức lương cơ sở"} className="custom-column" key="mucLuongCoSo" dataIndex="mucLuongCoSo" render={(value, record, index) => (
                    <>{formatVND(value)}</>
                )} />
                {loaiChuKy === 1 &&
                    <Column title="Mức thù lao/tháng của thành viên HĐQL không chuyên trách" className="custom-column" key="mucThuLaoCoBanHDQLKCT" dataIndex="mucThuLaoCoBanHDQLKCT" render={(value, record, index) => (
                        <>{formatVND(value)}</>
                    )} />
                }
                {loaiChuKy === 1 &&
                    <Column title="Mức chi phụ cấp hàng tháng" className="custom-column" key="mucChiHangThang" dataIndex="mucChiHangThang" render={(value, record, index) => (
                        <>{formatVND(value)}</>
                    )} />
                }
                <Column title="Số tháng làm việc" align="center" key="soThangLamViec" dataIndex="soThangLamViec" render={(value, record, idx) => {
                    if (isEdit) {
                        return <Input value={value} type="number" step="0.1" onChange={(e) => {
                            if (parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > 3) {
                                toast.error("Số tháng làm việc đã nhập không hợp lệ")
                            } else {
                                dataLuongBoSung[idx].soThangLamViec = parseFloat(e.target.value);
                                dataLuongBoSung[idx].mucLuongDuocNhan = dataLuongBoSung[idx].heSo * dataLuongBoSung[idx].mucLuongCoSo * parseFloat(e.target.value)
                                setDataLuongBoSung([...dataLuongBoSung]);
                            }

                            if (e.target.value == "") {
                                dataLuongBoSung[idx].soThangLamViec = 0;
                                dataLuongBoSung[idx].mucLuongDuocNhan = 0
                                setDataLuongBoSung([...dataLuongBoSung]);
                            }
                        }} />
                    }
                    return value;
                }} />
                <Column title={loaiChuKy === 1 ? "Phụ cấp được nhận" : "Thành tiền"} className="custom-column" key="mucLuongDuocNhan" dataIndex="mucLuongDuocNhan" render={(value, record, index) => (
                    <>{formatVND(value)}</>
                )} />
                {trangThai <= 0 && <Column
                    title={
                        <input
                            type="checkbox"
                            checked={checkAll}
                            onChange={(e) => {
                                setCheckAll(e.target.checked);
                                if (e.target.checked) {                                    
                                    let tempData = [...dataLuongBoSung];
                                    tempData.forEach((item) => {
                                        item.checked = true
                                    });
                                    setDataLuongBoSung(tempData);
                                }
                                else {
                                    let tempData = [...dataLuongBoSung];
                                    tempData.forEach((item) => {
                                        item.checked = false
                                    });
                                    setDataLuongBoSung(tempData);
                                }
                            }}
                        />
                    }
                    key="choose"
                    render={(value, record, index) =>
                    (
                        <div className='text-center' key={value.idNhanVien + "checkboxchoose"}>
                            <input type="checkbox"
                                data-index={value?.idNhanVien}
                                checked={value?.checked}
                                onChange={(e) => {
                                    dataLuongBoSung[index].checked = e.target.checked;
                                    setDataLuongBoSung([...dataLuongBoSung]);
                                }}
                            />
                        </div>
                    )
                    }
                /> }
            </Table>
        </div>
    </section >
}

export default ChiTietPhuCapTGV;